import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Welcome from "./components/Welcome";
import Archive from "./components/Archive";
import Events from "./components/Events";
import Palestine from "./components/Palestine";
import Contact from "./components/Contact";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import "./App.css";

function App() {
  return (
    <Router>
      <Navbar />
      <div className="body">
        <Routes>
          <Route path="/" element={<Welcome />} />
          <Route path="/zines" element={<Archive />} />
          <Route path="/events" element={<Events />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/palestine-reading-list" element={<Palestine />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;
